module.exports = __webpack_public_path__ + "img/btn_service.d6aad0c0.png";